import React, { useState, useCallback, useContext } from 'react';
import {
  Grid,
  Card,
  CardContent,
  CardHeader,
  Stack,
} from '@mui/material';
import { MyButton } from '../../../common/components';
import { IconUsers, IconPlus } from '@tabler/icons';
import AddClinicUserDialog from './AddClinicUserDialog';
import ClinicContext from '../../context/ClinicContext';
import { isEmpty } from 'lodash';
import AddUserFromOtherClinicDialog from './AddUserFromOtherClinicDialog';
import UsersTable from '../../../management/table/UsersTable';

export default function ClinicUsersTable({ data, loading, providers }) {
  const { id: clinicId, refetch } = useContext(ClinicContext);
  const [addUserDialogVisible, setAddUserDialogVisible] = useState(false);
  const [addUserFromOtherClinicDialogVisible, setAddUserFromOtherClinicDialogVisible] = useState(false);

  const handleAddUserFromOtherClinicDialogClose = useCallback((isSuccess = false) => {
    setAddUserFromOtherClinicDialogVisible(false);
    if (isSuccess) {
      refetch();
    }
  }, [refetch]);

  const handleAddUserDialogClose = useCallback((isSuccess = false) => {
    setAddUserDialogVisible(false);
    if (isSuccess) {
      refetch();
    }
  }, [refetch]);

  return (<>
    <Card>
      <CardHeader
        avatar={<IconUsers />}
        action={
          <Stack direction="row">
            <MyButton startIcon={<IconPlus />}
              onClick={setAddUserDialogVisible.bind(this, true)}
              sx={{ color: '#fff' }}>
              Add User
            </MyButton>
            <MyButton startIcon={<IconPlus />}
              onClick={setAddUserFromOtherClinicDialogVisible.bind(this, true)}
              sx={{ color: '#fff' }}>
              Import Existing User
            </MyButton>
          </Stack>
        }
        title="Users"
      />
      <CardContent>
        <Grid sx={{ m: -3 }}>
          <UsersTable
            loading={loading}
            data={data}
            showToolbar={true}
            updateRole={false}
            minTableHeight={400}
          />
        </Grid>
      </CardContent>
    </Card>
    <AddClinicUserDialog clinicId={clinicId}
      open={addUserDialogVisible}
      providers={!isEmpty(providers) ? providers : []}
      onClose={handleAddUserDialogClose} />

    <AddUserFromOtherClinicDialog clinicId={clinicId}
      open={addUserFromOtherClinicDialogVisible}
      onClose={handleAddUserFromOtherClinicDialogClose} />
  </>);
}